import styled from 'styled-components';
import { Modal } from '../comps';

export const StyledModal = styled(Modal)`
  width: 840px;
  max-width: calc(100vw - 40px);

  .mvm-rows {
    display: grid;
    grid-gap: 16px;
  }

  .mvm-row {
    display: grid;
    grid-template-columns: 1fr 340px;
    grid-gap: 20px;
    align-items: center;
  }

  .mvm-row__pill {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
  }

  .mvm-row__currency {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .mvm-buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;

    /* Skip-less flavours (populate) render a single full-width SAVE. */
    &.mvm-buttons--single {
      grid-template-columns: 1fr;
    }
  }
`;
